import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
const db = firebaseApp.database()

const commentsRef = db.ref('comments')
const currentCommentsRef = (currentUserId) => { return db.ref('comments/' + currentUserId) }

export const commentsModule = {
  namespaced: true,
  state: {
    comments: {},
    currentComments: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_COMMENTS]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_COMMENTS')
      bindFirebaseRef('comments', commentsRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_COMMENTS]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_COMMENTS', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentComments', currentCommentsRef(currentUserId), { wait: true })
    }),
    [getterConstants.SEND_NEW_COMMENT]: firebaseAction((context, value) => {
      const newSendCommentRef = commentsRef.push()
      // newSendCommentRef.set(value).then(function (newSendCommentRef) {
      //   console.log(newSendCommentRef.key)
      // })
      newSendCommentRef.set(value)
      // console.log(newSendCommentRef.key)
      // const newSendCommentTargetRef = commentsRef.push()
      // let getKey = newSendCommentRef.set(value)
      console.log('sendcomment', value)
      const resolveComment = {
        item: value,
        key: newSendCommentRef.key
      }
      return resolveComment
    }),
    [getterConstants.SET_LIKES]: firebaseAction((context, value) => {
      const setLikeRef = db.ref(
        'comments/' + value.key + '/likes/' + value.userId
      )
      setLikeRef.set(1)
    }),
    [getterConstants.REMOVE_LIKES]: firebaseAction((context, value) => {
      const removeLikeRef = db.ref(
        'comments/' + value.key + '/likes/' + value.userId
      )
      removeLikeRef.remove()
    }),
    [getterConstants.REMOVE_COMMENT]: firebaseAction((context, value) => {
      console.log('removeComment', value)
      let removeTargetCommentRef
      let removeCommentRef = db.ref('comments/' + value.commentId)
      // let removeCommentFlagRef = db.ref('comments/' + value.commentId + '/isDelete')
      let removeCommentImageRef = db.ref('comments/' + value.commentId + '/uploadedFile')
      let setText = value.remtext
      console.log('setText', setText)
      if (value.byManager) {
        setText = '** ' + setText + ' **'
        if (value.uploadedFile) {
          removeCommentImageRef.remove()
        }
      }
      if (value.target === 'rtfbs') {
        removeTargetCommentRef = db.ref('rtfbs/' + value.targetId + '/comments/' + value.commentId)
      } else if (value.target.indexOf('1on1') >= 0) {
        removeTargetCommentRef = db.ref('1on1s/' + value.targetOwner + '/' + value.targetId + '/comments/' + value.commentId)
      } else {
        removeTargetCommentRef = db.ref(value.target + '/' + value.targetOwner + '/' + value.targetId + '/comments/' + value.commentId)
      }
      if (value.parentId === 'parent') {
        // 親コメントの場合
        if (value.uploadedFile) {
          removeCommentImageRef.remove()
        }
        removeCommentRef.child('contentText').set(setText)
        removeCommentRef.child('isDelete').set(1)
        // removeCommentFlagRef.set(1)
        removeTargetCommentRef.set(0)
      } else if (value.parentId === 'notParent') {
        // 子なしコメントの場合
        removeCommentRef.remove()
        // removeCommentRef.child('isDelete').set(1)
        // removeCommentFlagRef.set(1)
        removeTargetCommentRef.remove()
      } else {
        // 子コメントの場合
        const dbRef = db.ref(('comments/' + value.parentId))
        dbRef.child('isDelete').once('value').then(ss => {
          // targetItemの配下のcommentの削除用
          const removeParentTargetCommentRef = db.ref(value.target + '/' + value.targetOwner + '/' + value.targetId + '/comments/' + value.parentId)
          if (ss.exists()) {
            dbRef.remove()
            removeParentTargetCommentRef.remove()
          }
        })
        // removeCommentRef.child('contentText').set(setText)
        // removeCommentRef.child('isDelete').set(1)
        // removeTargetCommentRef.set(0)
        removeCommentRef.remove()
        removeTargetCommentRef.remove()
      }
    }),
    [getterConstants.SET_NEW_COMMENT]: firebaseAction((context, value) => {
      let num = value.item.target.indexOf('_')
      let newSetCommentRef
      if (num !== -1) {
        // console.log('return not -1')
        newSetCommentRef = db.ref(
          '1on1s/' +
            value.userId +
            '/' +
            value.item.targetId +
            '/comments/' +
            value.key
        )
      } else if (value.item.target === 'rtfbs') {
        console.log(value.item)
        newSetCommentRef = db.ref(
          'rtfbs/' + value.item.targetId + '/comments/' + value.key
        )
      } else {
        // console.log('return else')
        newSetCommentRef = db.ref(
          value.item.target +
            '/' +
            value.userId +
            '/' +
            value.item.targetId +
            '/comments/' +
            value.key
        )
      }
      console.log('getterConstants.SET_NEW_COMMENT', value, newSetCommentRef)
      newSetCommentRef.set(1)
    })
  },
  getters: {
    getComments: state => state.comments,
    getCurrentComments: state => state.currentComments,
    getIsReadComment: (state, getters, rootState) => (target, targetOwner, targetId, commentId) => {
      let comment
      try {
        comment = rootState.readTimes['comments'][target][targetOwner][targetId][commentId]
      } catch (e) {
        return false
      }
      return !!comment
    },
    getCommentsByItemId: state => (itemId, targetType) => {
      // commentオブジェクトの配列を返します
      let comments = []
      const stateComments = state.comments
      // console.log('getCommentsByItemId:', itemId, targetType)
      // console.log('getCommentsByItemId:', itemId, targetType, stateComments)
      if (stateComments) {
        for (let commentId in stateComments) {
          // console.log(commentId, stateComments[commentId])
          // if (stateComments[comment].targetId === itemId && stateComments[comment].target === targetType && !stateComments[comment].parentId) {
          if (stateComments[commentId] && (stateComments[commentId].targetId === itemId && stateComments[commentId].target === targetType)) {
            stateComments[commentId].id = commentId
            comments.push(stateComments[commentId])
          }
        }
      }
      // console.log('Parent Comments', comments)
      return comments
    },
    getCommentsByCommentIdsTargetType: state => (commentIds, targetType) => {
      // commentIds には各アイテムのcomments下が渡されることを想定しています。
      let comments = []
      const stateComments = state.comments
      if (stateComments) {
        for (let commentId in commentIds) {
          if (stateComments[commentId] && stateComments[commentId].target === targetType) {
            stateComments[commentId].id = commentId
            comments.push(stateComments[commentId])
          }
        }
      }
      return comments
    },
    getChildCommentsByParentId: state => (parentId, targetType) => {
      // childCommentオブジェクトの配列を返します
      let comments = []
      const stateComments = state.comments
      for (let comment in stateComments) {
        // if (stateComments[comment].parentId && stateComments[comment].parentId === parentId && stateComments[comment].target === targetType) {
        if (
          stateComments[comment].RootParentId &&
          stateComments[comment].RootParentId === parentId &&
          stateComments[comment].target === targetType
        ) {
          stateComments[comment].id = comment
          comments.push(stateComments[comment])
        }
      }
      // console.log('childComment', comments)
      return comments
    },
    getCommentsByUserId: state => (userId, isAdmin) => {
      let comments = []
      const stateComments = state.comments
      for (let commentId in stateComments) {
        if (stateComments[commentId].userId === userId) {
          comments.push({
            comment: stateComments[commentId],
            key: commentId
          })
        }
      }
      // console.log('こめんとだよ', comments)
      return comments
    },
    getIsReadLikeComment: (state, getters, rootState) => (targetOwner, targetItem, likeOwner) => {
      let like
      try {
        like = rootState.readTimes['likes']['comments'][targetOwner][targetItem][likeOwner]
      } catch (e) {
        return false
      }
      return !!like
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/comments.js